module.exports = __webpack_public_path__ + "img/loading-stream.b10cb869.gif";